import { type DriveFile } from '@/shared/DriveTypes';
import { type Cache, preload } from 'swr';
import { isBun, LEGACY, prefetchDisabled } from './constants';
import { exportFile } from './DriveAPI';
import { useStore } from './store';
import { assertType, getId, getMimeType, isExportable } from './utils';

const prefetchTimeouts = new Map<string, NodeJS.Timeout>();

export const prefetchTimeout = (file: DriveFile, cache: Cache, delay = 500) => {
  if (LEGACY || prefetchDisabled || !isExportable(file) || isBun || useStore.getState().isTablet) return;
  if (prefetchTimeouts.has(file.id)) return;
  const timeout = setTimeout(() => {
    prefetchTimeouts.delete(file.id);
    prefetch(file, cache);
  }, delay);
  prefetchTimeouts.set(file.id, timeout);
};
export const clearPrefetchTimeout = (file: DriveFile) => {
  if (LEGACY || !isExportable(file) || isBun || useStore.getState().isTablet) return;
  const timeout = prefetchTimeouts.get(file.id);
  if (timeout) {
    clearTimeout(timeout);
    prefetchTimeouts.delete(file.id);
  }
};

export const prefetch = (file: DriveFile, cache: Cache) => {
  if (LEGACY || prefetchDisabled || !isExportable(file) || isBun) return;
  if (prefetchTimeouts.has(file.id)) return clearPrefetchTimeout(file);
  // The cache is a Map<string, string> during the user session so we can use map methods
  assertType<Map<string, string>>(cache);
  const isCached = Boolean(cache.has(`/drive/v3/files/${getId(file)}/export`));
  if (isCached) return;
  const id = file ? getId(file) : undefined;
  const mimeType = getMimeType(file);
  if (!id) throw new Error('No id provided');
  if (!mimeType) throw new Error('No mimeType provided');
  void preload(`/drive/v3/files/${id}/export`, () => exportFile({ id, file }));
};
